import { useCallback } from "react";

function useLocalStorage() {
  // Set a value in localStorage (with error handling)
  const set = useCallback((key: string, value: string): void => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(`❌ Failed to set ${key}:`, error);
    }
  }, []);

  // Get a value from localStorage
  const get = useCallback((key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`❌ Failed to get ${key}:`, error);
      return null;
    }
  }, []);

  // Remove a value from localStorage
  const remove = useCallback((key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`❌ Failed to remove ${key}:`, error);
    }
  }, []);

  return { set, get, remove };
}

export default useLocalStorage;
